import { render, staticRenderFns } from "./DesignShare.vue?vue&type=template&id=2cff6d9d&scoped=true&"
import script from "./DesignShare.vue?vue&type=script&lang=js&"
export * from "./DesignShare.vue?vue&type=script&lang=js&"
import style0 from "./DesignShare.vue?vue&type=style&index=0&id=2cff6d9d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cff6d9d",
  null
  
)

export default component.exports